exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".stage-transition__icon {\n  vertical-align: middle;\n}\n", ""]);

